let report = {
    $detailsShowAll: $('#js-reportDetailsShowAll'),
    $mapCanvas: $('#js-reportMapCanvas'),
    map: null,
    marker: null,
    selectorDetail: 'report-details-detail',

    init() {
        // app.modules.googleMaps.load(this.initMap.bind(this))
        this.initDetails()
    },

    initDetails() {
        this.$detailsShowAll.on('click', (e) => {
            e.preventDefault()
            $(e.currentTarget).hide()
            $(this.selectorDetail).show()

        })
    },

    initISS() {
        let iss
        let issMarker
        let orbitCoords
        let orbitCoordsObj
        let orbit
        let timestamp
        let tle

        if (window.hasOwnProperty('report')) {
            if (window.report.iss_tle[0] !== '') {
                tle = window.report.iss_tle
                timestamp = window.report.timestamp
                iss = new TLEJS()

                issMarker = new google.maps.Marker({
                    icon: {
                        anchor: new google.maps.Point(14, 14),
                        scaledSize: new google.maps.Size(28, 28),
                        size: new google.maps.Size(56, 56),
                        url: '/assets/img/marker-iss.png'
                    },
                    map: this.map,
                    position: iss.getLatLon(tle, timestamp)
                })

                orbitCoords = iss.getGroundTrackLatLng(tle, 5000, timestamp)
                orbitCoordsObj = orbitCoords[1].map((pos) => {
                    return {lat: pos[0], lng: pos[1]}
                })

                orbit = new google.maps.Polyline({
                    geodesic: true,
                    path: orbitCoordsObj,
                    strokeColor: '#FF5533',
                    strokeOpacity: 0.75,
                    strokeWeight: 2
                })
                orbit.setMap(this.map)
            }
        }
    },

    initMap() {
        let position
        let positionIcon
        let latLng

        this.map = new google.maps.Map(this.$mapCanvas.get(0), {
            center: new google.maps.LatLng(52.132633, 5.291266),
            mapTypeControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            streetViewControl: false,
            styles: app.modules.mapStyles.styles,
            zoom: 6,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
        })

        if (window.hasOwnProperty('report')) {
            position = window.report.position
            latLng = new google.maps.LatLng(
                window.report.location_lat,
                window.report.location_lng
            );

            positionIcon = {
                anchor: new google.maps.Point(96, 96),
                origin: new google.maps.Point(0, 0),
                scaledSize: new google.maps.Size(192, 192),
                size: new google.maps.Size(384, 384),
                url: `/assets/img/marker-position-${position}.png`
            }

            this.marker = new google.maps.Marker({
                /*
                animation: google.maps.Animation.DROP,
                icon: {
                    anchor: new google.maps.Point(15, 45),
                    scaledSize: new google.maps.Size(30, 45),
                    size: new google.maps.Size(60, 90),
                    url: '/assets/img/marker.png'
                },
                */
                icon: positionIcon,
                map: this.map,
                position: latLng
            })

            this.initISS()
        }
    },

    onNewComment(comment) {
        if (comment.id && window.hasOwnProperty('report')) {
            $.post(`/melding/${window.report.id}/reactie`, {comment_id: comment.id});
        }
    }
}

export default report